var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.useTitle
      ? _c("h4", [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.element && _vm.element.info
                  ? JSON.parse(_vm.element.info).title
                  : _vm.formUi.name
              ) +
              "\n  "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "jCalendar container-calendar m__t--15" },
      [
        _c("vue-cal", {
          attrs: {
            events: _vm.events,
            "disable-views": _vm.disableViews,
            "default-view": "month",
            "events-on-month-view": "short"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40acfd66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40acfd66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/widget-card/jCalenderViewWidget.vue
// module id = null
// module chunks = 